import { render } from "./NimpStock.vue?vue&type=template&id=727c0848&scoped=true"
import script from "./NimpStock.vue?vue&type=script&lang=js"
export * from "./NimpStock.vue?vue&type=script&lang=js"

import "./NimpStock.vue?vue&type=style&index=0&id=727c0848&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-727c0848"]])

export default __exports__